// @flow

import * as ReduxActions from 'redux-actions';
import type {
  Action,
  ActionType,
}                        from '../../../redux/redux.types';
import type { Config }   from '../../config';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type IsPersonalisedActionPayload = {|
  causedBy: Array<string>,
  config: $ReadOnly<Config>,
|};

export type IsPersonalisedActionArgs = {|
  causedBy: Array<string>,
  config: $ReadOnly<Config>,
|};

export type IsPersonalisedAction = Action<typeof type, IsPersonalisedActionPayload, void>;


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: ActionType = 'PERSONAL_CONTENT:IS_PERSONALISED';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

/**
 * @type {{(IsPersonalisedActionArgs): IsPersonalisedAction, toString}}
 */
const isPersonalised: (IsPersonalisedActionArgs) => IsPersonalisedAction = ReduxActions.createAction(type);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default isPersonalised;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/actions/isPersonalised.js